import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import styled from "styled-components";
import CommonApi from "../../../api/common.api";
import PopupApi from "../../../api/popup.api";
import DelBtn from "../../../component/atoms/button/delBtn";
import ImgInput from "../../../component/atoms/input/imgInput";
import MainInput from "../../../component/atoms/input/mainInput";
import DetailPage from "../../../component/atoms/layout/detail/detailPage";
import DetailPageForm from "../../../component/atoms/layout/detail/detailPageForm";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import DetailTop from "../../../component/atoms/layout/detail/detailTop";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import DetailFormTitle from "../../../component/atoms/text/detail/detailFormTitle";
import DetailPageTitle from "../../../component/atoms/text/detail/detailPageTitle";
import GoBack from "../../../component/molecules/goBack";
import ImgPreview from "../../../component/molecules/imgPreview";
import Header from "../../../component/organisms/header";
import Sidebar from "../../../component/organisms/sidebar";
import Modal from "../../../component/templates/Modal";
import { imgUrl } from "../../../constants/url";
import { isNull } from "../../../util/check";
import { errorHandler } from "../../../util/errorHandler";
import { modalMsg } from "../../../util/modalMsg";
import { toastMsg } from "../../../util/toastMsg";
import PretendardText from "../../../component/atoms/text/pretendardText";
import LectureApi from "../../../api/lecture.api";
import { route } from "../../../router/route";
import VideoPreview from "../../../component/molecules/videoPreview";
import Loading from "../../../component/templates/Loading";

const CurriculumAdd = () => {
  const navigate = useNavigate();
  let { id } = useParams();
  const [lectureType, setLectureType] = useState("");

  useEffect(() => {
    const loadLectureType = async () => {
      try {
        const response = (await LectureApi.getLectureById(id)).data.data.content;
        setLectureType(response.lectureCategoryType);
      } catch (error) {
        errorHandler(error);
      }
    };

    loadLectureType();
  }, [id]);

  const lectureListRoute =
    lectureType === "PAID_LECTURE"
      ? route.lecture_lecture_paid
      : route.lecture_lecture_finance;

  const defaultForm = {
    title: "",
    content: "",
    file: "",
    fileUrl: "",
    videoOriginFileName: "",
    videoServerFileName: "",
  };

  // ----- 정보 가져오기
  const [lectureCurriculumList, setLectureCurriculumList] = useState([]);

  const delImg = (index) => {
    const copyArr = [...lectureCurriculumList];
    copyArr[index].file = "";
    copyArr[index].fileUrl = "";
    copyArr[index].videoOriginFileName = "";
    copyArr[index].videoServerFileName = "";

    setLectureCurriculumList(copyArr);
  };

  //이미지 추가, 삭제
  // const inputFile = (e, index) => {
  //   const file = e.target.files[0];

  //   const fileReader = new FileReader();
  //   fileReader.readAsDataURL(file);
  //   fileReader.onload = (value) => {
  //     const copyArr = [...lectureCurriculumList];
  //     copyArr[index].file = file;
  //     copyArr[index].fileUrl = value.target.result;

  //     setLectureCurriculumList(copyArr);
  //   };
  //   e.target.value = "";
  // };
  // const inputFile = (e, index) => {
  //   const file = e.target.files[0];

  //   if (!file) return;

  //   const copyArr = [...lectureCurriculumList];
  //   copyArr[index].file = file;

  //   // 비디오 파일인지 확인
  //   if (file.type.startsWith("video/")) {
  //     // 비디오의 URL을 fileUrl로 저장
  //     const videoUrl = URL.createObjectURL(file);
  //     copyArr[index].fileUrl = videoUrl;

  //     setLectureCurriculumList(copyArr);
  //   } else {
  //     // 비디오가 아닌 경우 기존 로직 유지
  //     const fileReader = new FileReader();
  //     fileReader.readAsDataURL(file);
  //     fileReader.onload = (value) => {
  //       copyArr[index].fileUrl = value.target.result;
  //       setLectureCurriculumList(copyArr);
  //     };
  //   }

  //   e.target.value = "";
  // };

  const inputFile = (e, index) => {
    const file = e.target.files[0];

    if (!file) return;
    if (!file.type.startsWith("video/")) {
      e.target.value = "";
      return toast("영상 파일만 등록할 수 있습니다.");
    }

    const copyArr = [...lectureCurriculumList];
    copyArr[index].file = file;

    // 비디오 파일 처리
    const videoUrl = URL.createObjectURL(file);
    copyArr[index].fileUrl = videoUrl;

    // 비디오의 재생 시간(playTime) 얻기
    const videoElement = document.createElement("video");
    videoElement.src = videoUrl;

    videoElement.onloadedmetadata = () => {
      const playTime = videoElement.duration; // 재생 시간 (초 단위)
      copyArr[index].playTime = Math.round(playTime); // 소수점 반올림
      setLectureCurriculumList(copyArr);
    };

    e.target.value = ""; // 파일 input 초기화
  };

  //저장하기
  const [saveModalOpen, setSaveModalOpen] = useState(false);

  const saveBtnHandler = () => {
    if (lectureCurriculumList.length === 0) {
      return toast("커리큘럼을 1개 이상 추가해주세요.");
    }

    const invalidIndex = lectureCurriculumList.findIndex(
      (item) =>
        (isNull(item.file) && isNull(item.videoServerFileName)) ||
        isNull(item.title?.trim()) ||
        isNull(item.content?.trim())
    );

    if (invalidIndex !== -1) {
      return toast(
        `${invalidIndex + 1}강의 영상, 제목, 설명을 모두 입력해주세요.`
      );
    }

    setSaveModalOpen(true);
  };

  const [uploadLoading, setUploadLoading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  const saveFunc = async () => {
    try {
      const totalBytes = lectureCurriculumList.reduce(
        (total, item) => total + (item.file?.size || 0),
        0
      );
      const uploadedBytes = {};

      const list = await Promise.all(
        lectureCurriculumList.map(async (item, index) => {
          const data = {
            title: item.title,
            content: item.content,
            videoOriginFileName: item.videoOriginFileName,
            videoServerFileName: item.videoServerFileName,
            playTime: item.playTime,
          };

          // 파일이 있는 경우 업로드 처리
          if (!isNull(item.file)) {
            const result = await fileUpload(item.file, (progressEvent) => {
              uploadedBytes[index] = progressEvent.loaded;
              const loaded = Object.values(uploadedBytes).reduce(
                (total, value) => total + value,
                0
              );
              setUploadProgress(
                totalBytes > 0 ? Math.min(100, Math.round((loaded / totalBytes) * 100)) : 100
              );
            });
            data.videoOriginFileName = result.imageOriginFileName;
            data.videoServerFileName = result.imageServerFileName;
          }

          return data; // 비동기 작업 결과 반환
        })
      );

      await LectureApi.addCurriculum(id, { lectureCurriculumList: list });
      toast(toastMsg.update);

      setUploadProgress(100);
      setUploadLoading(false);
      navigate(lectureListRoute);
    } catch (error) {
      setUploadLoading(false);
      setSaveModalOpen(false);
      errorHandler(error);
      toast("영상 업로드에 실패했습니다. 다시 시도해주세요.");
    }
  };

  // 파일 업로드
  const fileUpload = async (file, onUploadProgress) => {
    try {
      const response = (
        await CommonApi.getFileUploadUrl({
          path: "lecture",
          originalFileName: file.name,
          contentType: file.type || "application/octet-stream",
        })
      ).data.data;

      await CommonApi.cloudFileUpload(
        response.uploadUrl,
        file,
        onUploadProgress
      );

      return {
        imageOriginFileName: file.name,
        imageServerFileName: response.serverFileName,
      };
    } catch (directUploadError) {
      const formData = new FormData();
      formData.append("path", "lecture");
      formData.append("file", file);

      const response = (
        await CommonApi.fileUpload(formData, onUploadProgress)
      ).data.data;

      return {
        imageOriginFileName: file.name,
        imageServerFileName: response.serverFileName,
      };
    }
  };

  const addCurriculum = () => {
    setLectureCurriculumList((prevInfo) => [...prevInfo, defaultForm]);
  };

  const delCurriculum = (index) => {
    const copyArr = [...lectureCurriculumList];
    copyArr.splice(index, 1);
    setLectureCurriculumList(copyArr);
  };

  return (
    <>
      <Header />
      <MainLayout>
        <Sidebar />
        <DetailPageLayout>
          <DetailTop>
            <GoBack onClick={() => navigate(lectureListRoute)} />
          </DetailTop>
          {lectureCurriculumList.map((item, index) => {
            return (
              <DetailPage key={index}>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <DetailPageTitle>커리큘럼 {index + 1}강</DetailPageTitle>
                  <DelBtn
                    style={{
                      borderColor: "#DFE1E4",
                      padding: "0 8px",
                      borderRadius: "4px",
                      height: "25px",
                      fontSize: "14px",
                    }}
                    onClick={() => delCurriculum(index)}
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "20px",
                  }}
                >
                  <DetailPageForm style={{ alignItems: "flex-start" }}>
                    <DetailFormTitle>영상 업로드*</DetailFormTitle>
                    {item.imageServerFileName || item.fileUrl ? (
                      <VideoPreview
                        fileUrl={item.fileUrl ? item.fileUrl : imgUrl + item.imageServerFileName}
                        onClick={() => {
                          delImg(index);
                        }}
                      />
                    ) : (
                      <ImgInput
                        id={`lecture${index}`}
                        accept={"video/*"}
                        onChange={(e) => {
                          inputFile(e, index);
                        }}
                      />
                    )}
                  </DetailPageForm>
                  <DetailPageForm>
                    <DetailFormTitle>제목*</DetailFormTitle>
                    <MainInput
                      style={{
                        width: "338px",
                      }}
                      type={"text"}
                      placeholder={"제목을 입력해 주세요."}
                      value={item.title}
                      onChange={(e) => {
                        const copyArr = [...lectureCurriculumList];
                        copyArr[index].title = e.target.value;
                        setLectureCurriculumList(copyArr);
                      }}
                    />
                  </DetailPageForm>
                  <DetailPageForm>
                    <DetailFormTitle>설명*</DetailFormTitle>
                    <MainInput
                      style={{
                        width: "744px",
                      }}
                      type={"text"}
                      placeholder={"내용을 입력해주세요"}
                      value={item.content}
                      onChange={(e) => {
                        const copyArr = [...lectureCurriculumList];
                        copyArr[index].content = e.target.value;
                        setLectureCurriculumList(copyArr);
                      }}
                    />
                  </DetailPageForm>
                </div>
              </DetailPage>
            );
          })}

          <AddBtn
            style={{
              backgroundColor: "#A4A9AD",
              border: "none",
              marginBottom: "20px",
            }}
            onClick={addCurriculum}
          >
            <PretendardText
              style={{
                color: "#FFFFFF",
                fontSize: "15px",
                fontWeight: 600,
              }}
            >
              + 커리큘럼 추가
            </PretendardText>
          </AddBtn>
          <AddBtn
            onClick={() => {
              saveBtnHandler();
            }}
          >
            <PretendardText
              style={{
                color: "#FFFFFF",
                fontSize: "15px",
                fontWeight: 600,
              }}
            >
              강의 등록하기
            </PretendardText>
          </AddBtn>
        </DetailPageLayout>
      </MainLayout>

      {saveModalOpen ? (
        <Modal
          title={modalMsg.update?.title}
          text={modalMsg.update?.content}
          setModalOpen={setSaveModalOpen}
          onClick={() => {
            setUploadProgress(0);
            setUploadLoading(true);
            saveFunc();
          }}
        />
      ) : null}

      {uploadLoading && (
        <ModalWrapper>
          <Loading title={`영상 업로드 중입니다. ${uploadProgress}%`} />
        </ModalWrapper>
      )}
    </>
  );
};

export default CurriculumAdd;

const AddBtn = styled.div`
  border: 1px solid #636c73;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 20px;
  cursor: pointer;
  background-color: #636c73;
`;

const ModalWrapper = styled.div.attrs((props) => {})`
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #00000060;
  position: fixed;
  top: 0;
  right: 0;
  z-index: 99;
`;
